import React from "react";
import { gql, useMutation } from "@apollo/client";
import {
  SendForgotPasswordEmailMutationMutation,
  SendForgotPasswordEmailMutationMutationVariables
} from "../../../../schemaTypes";

const FORGOT_PASSWORD_MUTATION = gql`
  mutation SendForgotPasswordEmailMutation($email: String!) {
    sendForgotPasswordEmail(email: $email) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface ForgotPasswordControllerProps {
  children: (
    data: {
      submit: (
        values: SendForgotPasswordEmailMutationMutationVariables
      ) => Promise<{
        errors: { path: string; message: string }[] | null;
        message: string | null;
      } | null>;
      loading: boolean;
      error?: Error;
    }
  ) => React.ReactElement | null;
}

export const ForgotPasswordController: React.FC<ForgotPasswordControllerProps> = ({ children }) => {
  const [forgotPasswordMutation, { loading, error }] = useMutation<
    SendForgotPasswordEmailMutationMutation,
    SendForgotPasswordEmailMutationMutationVariables
  >(FORGOT_PASSWORD_MUTATION);

  const submit = async (values: SendForgotPasswordEmailMutationMutationVariables) => {
    try {
      const { data } = await forgotPasswordMutation({ variables: values });
      if (data?.sendForgotPasswordEmail) {
        return {
          errors: data.sendForgotPasswordEmail.errors
            ? data.sendForgotPasswordEmail.errors
                .filter((e): e is { path: string; message: string } => e !== null)
                .map(({ path, message }) => ({ path, message }))
            : null,
          message: data.sendForgotPasswordEmail.message ?? null,
        };
      }
      return null;
    } catch {
      return null;
    }
  };

  return children({ submit, loading, error });
};